// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b0b1e8b","455":"4c9142af","977":"56d9c29f"}[chunkId] + ".chunk.js";
};